import { Action } from "redux";

import { put, retry } from "redux-saga/effects";
import {} from "redux-saga";

import { COMMIT, REVERT } from "redux-optimistic-ui";
import { customNotify } from "../../SharedComponent/Notification/index";
import { IOptReactionCreator } from "../actions/lib";

const appendOptimistic = (action, type, id) => {
  return {
    ...action,
    meta: {
      ...action.meta,
      optimistic: { type, id },
    },
  };
};

interface IReactions {
  success: IOptReactionCreator;
  failure: IOptReactionCreator;
}

interface IHandleOptimismOptions {
  maxTries?: number;
  delayMS?: number;
}

export function handleOptimism<
  A extends Action<string> & {
    payload: any;
    meta: { optimistic: { id: number } };
  }
>(
  saga: (action: A) => any,
  { failure, success }: IReactions,
  { maxTries = 3, delayMS = 5000 }: IHandleOptimismOptions = {}
) {
  return function* (action: A) {
    const {
      meta: {
        optimistic: { id },
      },
      payload,
    } = action;
    try {
      const result = yield retry(maxTries, delayMS, saga, action);

      yield put(appendOptimistic(success(result, id), COMMIT, id));
    } catch (e: any) {
      yield put(appendOptimistic(failure(payload, id), REVERT, id));
      if (e?.response?.status === 500) {
        customNotify.error("There is something wrong");
      }
    }
  };
}

// i18n.t(Strings.somethingWentWrong, {ns: 'orderingStatus'})
